import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { store } from "./Reducers/Store";
import { MainRouter } from "./Routes/MainRouter";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./MUI/Theme.ts";
import { NotificationProvider } from "./notifications/NotificacionProvider";
import NotificationModal from "./notifications/NotificacionModal";
import  { initAudio, unlockAudio } from "./notifications/useUnlockAudio";
import { TwilioDeviceProvider } from "./TwilioDeviceContext";
export const AppHumaya = () => {

  useEffect(()=>{
    if("Notification" in window){
      if(Notification.permission !=="granted"){
        Notification.requestPermission();
      }
    }
  },[])

 useEffect(()=>{
  initAudio();
  const unlock= ()=>{
    unlockAudio();
    document.removeEventListener("click",unlock)
  }

  document.addEventListener("click",unlock)
 },[])
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <NotificationProvider>
          <TwilioDeviceProvider>
            <NotificationModal />
            <MainRouter />
          </TwilioDeviceProvider>
        </NotificationProvider>
      </ThemeProvider>
    </Provider>
  );
};
